var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel granary-right-panel" }, [
    _c("div", { staticClass: "xq-box" }, [
      _c("div", { staticClass: "yzc-box" }, [
        _c("img", {
          staticClass: "icon-xmy",
          attrs: { src: require("images/granary/xmy/yzc-icon.png"), alt: "" },
        }),
        _c("div", { staticClass: "txt-box" }, [
          _c("div", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.xqList[0].name)),
          ]),
          _c("div", { staticClass: "total yzc-total" }, [
            _vm._v(_vm._s(_vm.xqList[0].total)),
          ]),
          _c("div", { staticClass: "year" }, [
            _vm._v(" 较2020"),
            _c("span", { staticClass: "add-txt" }, [
              _vm._v(_vm._s(_vm.xqList[0].add)),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "yjc-box" }, [
      _c("div", { staticClass: "yjc-item" }, [
        _c("div", { staticClass: "txt-box ync-txt" }, [
          _c("div", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.xqList[1].name)),
          ]),
          _c("div", { staticClass: "total ync-total" }, [
            _vm._v(_vm._s(_vm.xqList[1].total)),
          ]),
          _c("div", { staticClass: "year" }, [
            _vm._v(" 较2020"),
            _c("span", { staticClass: "add-txt" }, [
              _vm._v(_vm._s(_vm.xqList[1].add)),
            ]),
          ]),
        ]),
        _c("img", {
          staticClass: "icon-xmy",
          attrs: { src: require("images/granary/xmy/ync-icon.png"), alt: "" },
        }),
      ]),
      _c("div", { staticClass: "yjc-item" }, [
        _c("img", {
          staticClass: "icon-xmy",
          attrs: { src: require("images/granary/xmy/yjc-icon.png"), alt: "" },
        }),
        _c("div", { staticClass: "txt-box" }, [
          _c("div", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.xqList[2].name)),
          ]),
          _c("div", { staticClass: "total yjc-total" }, [
            _vm._v(_vm._s(_vm.xqList[2].total)),
          ]),
          _c("div", { staticClass: "year" }, [
            _vm._v(" 较2020 "),
            _c("span", { staticClass: "add-txt" }, [
              _vm._v(_vm._s(_vm.xqList[2].add)),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }